// extracted by mini-css-extract-plugin
export default {"container":"Scope_container__1u2mE","canvas":"Scope_canvas__VJifZ"};